<script>
  export default {
    name: 'channels-list-item',

    props: {
      channel: {
        type: Object,
        required: true
      }
    },

    computed: {
      colorClass: function () {
        return [`text-${this.channel.color}`]
      }
    },

    methods: {
      confirmDelete (channel) {
        this.$swal({
          title: 'Are you sure?',
          text: `You are about to delete channel '${channel.name}'`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          confirmButtonColor: '#d33',
          onOpen: () => {
            const audio = new Audio('http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3')
            return audio.play()
          }
        }).then((result) => {
          if (result.value) {
            // TODO: Trigger delete
            this.$store.dispatch('channels/removeChannel', this.channel)

            const audio = new Audio('http://soundbible.com/mp3/toilet_flush_clear-mike-koenig.mp3')
            return audio.play()
          }
        })
      }
    }
  }
</script>

<template>
  <tr>
    <th scope="row">
      <font-awesome-icon :icon="['far', 'play']" size="lg" class="mt-2 mr-3" :class="colorClass"/>
      <span>{{ channel.name }}</span>
    </th>
    <td>
      <span>{{ channel.screenLayout.name }}</span>
    </td>
    <td>
      <span>{{ channel.modified | moment('MM/DD/YY') }}</span>
    </td>
    <td>
      <ul class="actions">
        <li>
          <b-button :to="`/channels/${channel.channelId}`" variant="secondary">Edit</b-button>
        </li>
        <li>
          <a>
            <font-awesome-icon :icon="['far', 'object-ungroup']" size="lg" class="text-muted mt-2"/>
          </a>
        </li>
        <li>
          <a @click="confirmDelete(channel)">
            <font-awesome-icon :icon="['far', 'trash-alt']" size="lg" class="text-muted mt-2"/>
          </a>
        </li>
      </ul>
    </td>
  </tr>
</template>
